import Icon from 'helpers/svg-icon';
import { cefRed } from 'constants/variables';

const FacebookIcon = ({
  width = 12,
  height = 12,
  fillColor = cefRed,
  ...rest
}) => (
  <Icon width={width} height={height} viewBox="0 0 32 32" {...rest}>
    <path
      fill={fillColor}
      d="M0 0v32h32V0H0Zm20.51 13.62-.41 3.16h-2.72v8.1h-3.26v-8.1H11.4v-3.16h2.72v-2.33c0-2.7 1.65-4.17 4.07-4.17.81 0 1.62.04 2.43.13v2.82h-1.66c-1.31 0-1.56.63-1.56 1.54v2.02h3.12Z"
    />
  </Icon>
);

const XIcon = ({ width = 12, height = 12, fillColor = cefRed, ...rest }) => (
  <Icon width={width} height={height} viewBox="0 0 32 32" {...rest}>
    <path
      fill={fillColor}
      d="m16.16 14.61-4.35-6.22H9.49l5.39 7.71.68.97 4.61 6.6h2.32l-5.65-8.09-.68-.97z"
    />
    <path
      fill={fillColor}
      d="M0 0v32h32V0H0Zm19.46 24.75-4.67-6.8-5.85 6.8H7.43l6.69-7.77-6.68-9.73h5.1l4.42 6.43 5.54-6.43h1.51l-6.38 7.41 6.93 10.09h-5.1Z"
    />
  </Icon>
);

const InstagramIcon = ({
  width = 12,
  height = 12,
  fillColor = cefRed,
  ...rest
}) => (
  <Icon width={width} height={height} viewBox="0 0 32 32" {...rest}>
    <path
      fill={fillColor}
      d="M23.14 12.44c-.04-.86-.18-1.32-.31-1.63-.16-.41-.35-.7-.66-1.01-.31-.31-.6-.5-1.01-.65-.31-.12-.77-.26-1.63-.3-.93-.04-1.2-.05-3.55-.04-2.34 0-2.62.01-3.55.06-.86.04-1.32.18-1.63.31-.41.16-.7.35-1.01.66s-.5.6-.65 1.01c-.12.31-.26.78-.3 1.63-.04.93-.05 1.2-.04 3.55 0 2.34.01 2.62.06 3.55.04.86.18 1.32.31 1.63.16.41.35.7.66 1.01.31.31.6.5 1.01.65.31.12.77.26 1.63.3.93.04 1.2.05 3.55.04 2.34 0 2.62-.01 3.55-.06.86-.04 1.32-.18 1.63-.31.41-.16.7-.35 1.01-.66.31-.31.5-.6.66-1.01.12-.31.26-.78.3-1.63.04-.93.05-1.2.04-3.55s-.01-2.62-.06-3.55Zm-7.13 8.07c-2.49 0-4.51-2.01-4.52-4.5 0-2.49 2.01-4.51 4.5-4.52s4.51 2.01 4.52 4.5c0 2.49-2.01 4.51-4.5 4.52Zm4.67-8.15c-.58 0-1.05-.47-1.06-1.05 0-.58.47-1.05 1.05-1.06.58 0 1.05.47 1.06 1.05s-.47 1.05-1.05 1.06Z"
    />
    <path
      fill={fillColor}
      d="M15.99 13.07a2.926 2.926 0 1 0 .011 5.849 2.926 2.926 0 0 0-.011-5.849Z"
    />
    <path
      fill={fillColor}
      d="M0 0v32h32V0H0Zm24.73 19.6c-.04.93-.19 1.57-.4 2.13-.22.58-.52 1.07-1.01 1.56s-.98.79-1.55 1.02c-.56.22-1.19.37-2.13.41-.94.04-1.24.05-3.62.06s-2.68 0-3.62-.05c-.93-.04-1.57-.19-2.13-.4-.58-.22-1.07-.52-1.56-1.01s-.79-.98-1.02-1.55c-.22-.56-.37-1.2-.41-2.13-.05-.94-.06-1.24-.06-3.62s0-2.69.05-3.62c.04-.93.19-1.57.4-2.13.22-.58.52-1.07 1.01-1.56s.98-.79 1.55-1.02c.56-.22 1.2-.37 2.13-.41.94-.05 1.24-.06 3.62-.06s2.69 0 3.62.05c.93.04 1.57.19 2.13.4.58.22 1.07.52 1.56 1.01s.79.98 1.02 1.55c.22.56.37 1.19.41 2.13s.06 1.24.06 3.62 0 2.68-.05 3.62Z"
    />
  </Icon>
);

const TiktokIcon = ({
  width = 12,
  height = 12,
  fillColor = cefRed,
  ...rest
}) => (
  <Icon width={width} height={height} viewBox="0 0 32 32" {...rest}>
    <path
      fill={fillColor}
      d="M19.66,22.3c-.46,0-.84.37-.84.84s.37.84.84.84.84-.37.84-.84-.37-.84-.84-.84Z"
    />
    <path
      fill={fillColor}
      d="M0,0v32h32V0H0ZM14.62,11.3c.16,0,.32.01.48.03v1.98c-.15-.05-.31-.08-.48-.08-.9,0-1.63.73-1.63,1.63,0,.63.36,1.17.88,1.45.23.12.48.19.76.19.88,0,1.6-.7,1.63-1.57v-7.79h1.95c0,.17.02.33.05.49.14.74.58,1.38,1.19,1.77.42.28.93.44,1.47.44v1.94c-1.01,0-1.94-.32-2.7-.87v3.95c0,1.97-1.61,3.58-3.58,3.58-.76,0-1.47-.24-2.05-.65-.92-.65-1.53-1.72-1.53-2.93,0-1.97,1.61-3.58,3.58-3.58ZM9.71,21.54h-.81s0,3.31,0,3.31h-1.01v-3.31h-1.02s0-.9,0-.9h3.13l-.29.9ZM11.19,24.86h-1v-2.87s1,0,1,0v2.87ZM10.69,21.66c-.28,0-.51-.23-.51-.51s.23-.51.51-.51.51.23.51.51-.23.51-.51.51ZM13.83,24.86l-.94-1.4-.3.29v1.11h-1v-4.22h1v1.96l.99-.98h1.2s-1.26,1.22-1.26,1.22l1.41,2.02h-1.11ZM17.16,24.86h-1.01v-3.31h-1.02s0-.9,0-.9h3.2l-.29.9h-.88s0,3.31,0,3.31ZM19.66,24.86c-.95,0-1.72-.77-1.72-1.72s.77-1.72,1.72-1.72,1.72.77,1.72,1.72-.77,1.72-1.72,1.72ZM24.03,24.86l-.94-1.4-.3.29v1.11h-1v-4.22h1v1.96l.99-.98h1.2s-1.26,1.22-1.26,1.22l1.41,2.02h-1.11Z"
    />
  </Icon>
);

const LinkedinIcon = ({
  width = 12,
  height = 12,
  fillColor = cefRed,
  ...rest
}) => (
  <Icon width={width} height={height} viewBox="0 0 32 32" {...rest}>
    <path
      fill={fillColor}
      d="M0,0v32h32V0H0ZM11.63,24h-3.3v-10.67h3.3v10.67ZM11.35,11.36c-.37.37-.86.58-1.38.58-.39,0-.77-.11-1.1-.32-.33-.21-.58-.52-.73-.88s-.19-.76-.12-1.14.26-.73.54-1.01c.27-.28.63-.47,1.01-.54.38-.08.78-.04,1.14.11.36.15.67.4.89.72.22.32.33.71.33,1.09,0,.52-.2,1.02-.57,1.39ZM20.73,24v-5.6c0-1.54-.58-2.39-1.8-2.39-1.32,0-2.01.89-2.01,2.39v5.6h-3.17v-10.67h3.17v1.44c.34-.55.81-1,1.38-1.31.56-.31,1.2-.47,1.84-.46,2.26,0,3.88,1.38,3.88,4.24v6.75s-3.29,0-3.29,0Z"
    />
  </Icon>
);

export { FacebookIcon, XIcon, InstagramIcon, TiktokIcon, LinkedinIcon };
